export const animation = {
  maskShowDuration: 0.75,
  maskHideDuration: 1,
  blockDuration: 0.2,
  lineDuration: 0.06,
  wordDuration: 0.04,
  charDuration: 0.005,
  rootMargin: '0px 0px -10% 0px',
}
